import { VStack, Text, HStack, useMediaQuery } from "native-base";
import Stars from "../../components/stars";
import { COLORS } from "../../utils/colors";
import ProgressBar from "../../components/progressbar";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTWEIGHT } from "../../utils/fonts";

const Reviews = ({
  progressBarWidth = "30%",
  overallRating = "0",
  overallAverage = "0",
  overallStar = "0",
  totalReview = [0, 0, 0, 0, 0],
}) => {
  const overallReviews = [
    { percentage: "5", reviews: totalReview[4] },
    { percentage: "4", reviews: totalReview[3] },
    { percentage: "3", reviews: totalReview[2] },
    { percentage: "2", reviews: totalReview[1] },
    { percentage: "1", reviews: totalReview[0] },
  ];

  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return (
    <HStack mt={4} space={5}>
      <VStack display="flex" justifyContent="center" alignItems="center">
        <Text
          fontWeight="700"
          fontSize="33.796px"
          color={COLORS.CARD_DATE_COLOR}
        >
          {overallAverage}
        </Text>
        {overallAverage ? (
          <Stars stars={parseInt(overallAverage)} editable={false} />
        ) : (
          <Stars stars={0} editable={false} />
        )}
        <Text>{overallRating} Ratings</Text>
      </VStack>
      <VStack space={2} w={MobileWindow ? "50%" : progressBarWidth}>
        {overallReviews.map((review, ind) => {
          return (
            <HStack
              space={4}
              pl={
                (review.percentage === "1" && "1px") ||
                (review.percentage === "5" && "0.99")
              }
            >
              <Text fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}>
                {review.percentage}
              </Text>
              <ProgressBar value={review.reviews} ind={ind} />
            </HStack>
          );
        })}
      </VStack>
    </HStack>
  );
};

export default Reviews;
